import { Controller } from "stimulus"

export default class extends Controller {
  static targets = [ "item" ]
  static values = { selectedItem: String }

  selectedItemValueChanged() {
    this.itemTargets.forEach((el, i) => {
      el.dataset.radioSelectedValue = el.dataset.radioGroupItemValue == this.selectedItemValue      
    })
  }

  select(event) {
    this.selectedItemValue = event.currentTarget.dataset.radioGroupItemValue
  }
}
